import type { SegmentTrackedPages } from './types';

export function getNextSegmentTrackedPages(
  prev: SegmentTrackedPages,
  page: 1 | 2
): SegmentTrackedPages {
  if (page === 1 && prev.pageOne) return prev;
  if (page === 2 && prev.pageTwo) return prev;
  return {
    ...prev,
    ...(page === 1 ? { pageOne: true } : { pageTwo: true }),
  };
}
